import {
    ImageComponent as SourceImageComponent,
} from 'SourceComponent/Image/Image.component';
import React from 'react';
import './Image.override.style';
import image from "Src/assets/small_image.jpg";
import { ImageState } from '@scandipwa/scandipwa/src/component/Image/Image.config';

export class ImageComponent extends SourceImageComponent {
    // shouldComponentUpdate(nextprops) {
    //     return false;
    // }

    renderImageNotFound() {
        if (navigator.onLine) {
            return (
                <img src={image} />
            );
        }

        return <img src={image} className="Image-Content Image-Content_isOffline" />;
    }

    renderStyledImage() {
        const {
            alt,
            src,
            style,
            title,
        } = this.props;
        const {
            imageStatus,
            isLazyLoading,
        } = this.state;

        const imgSizes = {
            height: undefined,
            width: undefined,
        };

        imgSizes.height = this.image.current?.clientHeight;
        imgSizes.width = this.image.current?.clientWidth;

        return (
            <img
                className={"Image-Image" + (imageStatus === ImageState.IMAGE_LOADING ? " Image-Image_isLoading" : "")}
                src={src || ''}
                alt={alt}
                ref={this.image}
                // mods={{ isLoading: imageStatus === ImageState.IMAGE_LOADING }}
                style={style}
                title={title}
                onLoad={this.onLoad}
                onError={this.onError}
                height={imgSizes.height}
                width={imgSizes.width}
                loading={'lazy'}
            />
        );
    }

    renderPlainImage() {
        const {
            alt,
            src,
            style,
            title,
            className,
        } = this.props;
        const { isLazyLoading } = this.state;

        const imgSizes = {
            height: undefined,
            width: undefined,
        };

        imgSizes.height = this.image.current?.clientHeight;
        imgSizes.width = this.image.current?.clientWidth;

        return (
            <img
                className={className}
                src={src || ''}
                alt={alt}
                ref={this.image}
                style={style}
                title={title}
                height={imgSizes.height}
                width={imgSizes.width}
                onLoad={this.onLoad}
                onError={this.onError}
                loading={'lazy'}
            />
        );
    }

    render() {
        return this.renderImageContent();
    }
}

export default ImageComponent;
